const getElementIdFromResponse = (response) => {
  const responseWrapper = document.createElement('div');
  responseWrapper.innerHTML = response;
  const findingElem = responseWrapper.querySelector('[id^="product_reviews_container"]');

  if (findingElem) return findingElem.id;
  return '';
};

const reviewFetchByPage = async (page = 1) => {
  const paramsObj = {
    'ajax-catalog-element': 'Y',
    tab: 'reviews',
    PAGEN_2: `${page}`,
  };
  const params = new URLSearchParams(paramsObj);

  try {
    const rawResponse = await fetch(`${window.location.pathname}?${params}`);

    const response = await rawResponse.text();

    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const scriptsInit = () => {
  queueMicrotask(() => {
    window.attachedFilesInit();
    window.attachFilesInit();
    window.reviewsPaginationInit();
    window.initFormReview();
    window.popupsInit();
    // window.initReviewsLightBox();
    window.fullScreenViewer();
  });
};

const paginationLinkClickHandler = async (evt) => {
  evt.preventDefault();

  const pageCount = evt.target.dataset?.page;

  if (pageCount) {
    window.loaderShow('[id^="product_reviews_container"]');

    const response = await reviewFetchByPage(pageCount);
    const idFromResponse = getElementIdFromResponse(response);
    if (idFromResponse) {
      const container = document.querySelector(`#${idFromResponse}`);

      if (container) {
        container.innerHTML = response;
        scriptsInit();
      }
    }
  }
};

const init = () => {
  const reviewsBodyElem = document.querySelector('.goodscard-reviews__body');

  if (reviewsBodyElem) {
    const paginationListElem = reviewsBodyElem.querySelector('.pagination__list');

    if (paginationListElem) {
      const paginationItemsElems = paginationListElem.querySelectorAll('.pagination__item');

      paginationItemsElems.forEach((el) => {
        const paginationLink = el.querySelector('a');

        if (paginationLink) {
          paginationLink.addEventListener('click', paginationLinkClickHandler);
        }
      });
    }
  }
};

window.reviewsPaginationInit = init;
